// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Odoo_tickets_CreateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /odoo_tickets/create
 *
 * Validates support ticket creation requests. Title and description are
 * required; page_uri is optional context.
 */
import { registerContract } from './validate'

export interface Odoo_tickets_CreateInput {
name: string
description: string
page_uri?: string
}

registerContract('Odoo_tickets_CreateInput', {
  name:        { type: 'string',  required: true },
  description: { type: 'string',  required: true },
  page_uri:    { type: 'string',  required: false },
})
